import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'

class Circles extends Component {
  render() {
    return (
      <section className="circles">
        <div className="circle-break group">
          <div className="circle">
            <img src={assets('images/H_People-1.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-2.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-3.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-4.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-5.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-6.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-7.png')}/>
          </div>
          <div className="circle">
            <img src={assets('images/H_People-8.png')}/>
          </div>
        </div>
      </section>
    )
  }
}
Circles.contextTypes = {
}
Circles.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
  }
}

export default connect(mapStateToProps)(Circles)



// WEBPACK FOOTER //
// ./src/components/Home/Circles.js